import { FunctionComponent, PropsWithChildren } from 'react';
import { useHasRole } from '../../hooks/use-has-role';
import { Roles } from '../../model/common/Roles';

type Props = PropsWithChildren<{
  allowedRoles: Roles[];
}>;

export const RoleProtectedWrapper: FunctionComponent<Props> = ({ allowedRoles, children }) => {
  const hasAccess = useHasRole(allowedRoles);

  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
};
